import React, { type HTMLProps } from 'react'
import styled from '@emotion/styled'

const StyledSpan = styled.span({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  overflow: 'hidden',
  lineHeight: '1.5em',
})

interface Props extends HTMLProps<HTMLSpanElement> {
  children: string
}

export const ListAccountsTruncatableCell: React.FunctionComponent<Props> = props => (
  <StyledSpan title={props.children}>{props.children}</StyledSpan>
)
